/**
 * shadcn/ui Tooltip (Radix), on the brand tokens. Author: Mahmoud Ragab Ahmed.
 *
 * A tooltip NAMES a control; it never carries a reason or an instruction (UX_SPEC 3: a
 * disabled reason is printed beside the control, never hidden here). The content portals
 * to the body, so it carries `q-ui` itself and is never clipped by a scroll container.
 */
import { Tooltip as TooltipPrimitive } from "radix-ui";

import { cn } from "@/lib/utils";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({
  className,
  sideOffset = 8,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>): React.JSX.Element {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "q-ui z-80 rounded-md border border-rule-strong bg-popover px-2.5 py-1.5",
          "text-sm whitespace-nowrap text-popover-foreground shadow-xl",
          "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0",
          "data-[state=instant-open]:animate-in data-[state=instant-open]:fade-in-0",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
          className,
        )}
        {...props}
      >
        {children}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}
